/**
 * Admin API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssignStoredDynamicFormRequest { 
    officeGuids: Array<string>;
    officeFormParticipationAction?: AssignStoredDynamicFormRequest.OfficeFormParticipationActionEnum;
}
export namespace AssignStoredDynamicFormRequest {
    export const OfficeFormParticipationActionEnum = {
        Unchanged: 'UNCHANGED',
        Activate: 'ACTIVATE',
        Deactivate: 'DEACTIVATE'
    } as const;
    export type OfficeFormParticipationActionEnum = typeof OfficeFormParticipationActionEnum[keyof typeof OfficeFormParticipationActionEnum];
}


